import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const SkeletonChartTypeLegendItem = () => {
  return (
    <div className="legend-item flex-column flex-gap-15 flex-align-start-start">
      <div className="flex-column flex-gap-5 flex-align-start-start">
        <Skeleton width={27} height={13} style={{ borderRadius: 20 }} highlightColor="#218579" />
        <Skeleton width={80} height={20} highlightColor="#218579"/>
      </div>

      <div className="flex-column flex-gap-5 flex-align-start-start">
        <Skeleton width={100} height={14} highlightColor="#218579"/>
        <Skeleton width={120} height={13} highlightColor="#218579"/>
      </div>

      <div className="flex-column flex-gap-5 flex-align-start-start">
        <Skeleton width={140} height={15} highlightColor="#218579"/>
      </div>
    </div>
  );
};

export default SkeletonChartTypeLegendItem;
